import React, {useEffect, useState} from 'react';
import {v4 as uuid} from 'uuid';
import {Stack} from '@mui/material';
import {Box} from '@mui/system';
import {Modal} from '@lightricks/react-design-system';
import useUiInteractionEvent from '@contentlab/hooks/analytics/use-interaction-event';
import useViewDismissedEvent from '@contentlab/hooks/analytics/use-view-dismissed-event';
import useViewPresentedEvent from '@contentlab/hooks/analytics/use-view-presented-event';
import useContactSales from '@contentlab/hooks/use-contact-sales';
import {CONTENT_LAB_VIEW_NAMES} from '@/lib/analytics/analyticsConstants';
import styles from './FinalCreditModal.module.scss';
import FinalCreditModalContent from './FinalCreditModalContent';

function FinalCreditModal() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const onContactSalesClick = useContactSales({
    flowName: 'final-credit-contact-sales',
    interactionLocation: CONTENT_LAB_VIEW_NAMES.CREDIT_END_MODAL,
  });

  const {viewPresented} = useViewPresentedEvent();
  const {viewDismissed} = useViewDismissedEvent();
  const {uiInteraction} = useUiInteractionEvent();

  const [presentationId, setPresentationId] = useState<string>('');
  const handleClose = () => {
    const interactionId = uuid();
    uiInteraction({
      item_name: 'close_credit_end_modal',
      interaction_location: CONTENT_LAB_VIEW_NAMES.CREDIT_END_MODAL,
      interaction_id: interactionId,
    });
    viewDismissed({
      presentation_id: presentationId,
      interaction_id: interactionId,
      reason: 'modal_closed',
    });
    setIsModalOpen(false);
  };
  const handleRedirectToPricing = () => {
    const interactionId = uuid();
    uiInteraction({
      item_name: 'contact_sales',
      interaction_location: CONTENT_LAB_VIEW_NAMES.CREDIT_END_MODAL,
      interaction_id: interactionId,
    });
    viewDismissed({
      presentation_id: presentationId,
      interaction_id: interactionId,
      reason: 'contact_sales_button_pressed',
    });
    onContactSalesClick();
  };

  useEffect(() => {
    const shouldShowModal = localStorage.getItem('display_zero_credits_modal');
    if (shouldShowModal) {
      localStorage.removeItem('display_zero_credits_modal');
      setIsModalOpen(true);
      const newPresentationId = uuid();
      setPresentationId(newPresentationId);
      viewPresented({
        presentation_id: newPresentationId,
        view_name: CONTENT_LAB_VIEW_NAMES.CREDIT_END_MODAL,
        view_type: 'popup',
        view_location: 'editor_generate',
        source: 'editor_generate',
      });
    }
  }, []);
  return (
    <Modal
      showCloseButton
      open={isModalOpen}
      testID="final-credit-modal"
      width={800}
      handleClose={handleClose}
      fullScreen={false}
      contentClassName={styles.modalContent}
    >
      <Stack direction="row" width="800px">
        <FinalCreditModalContent
          onClose={handleClose}
          onRedirectToPricing={handleRedirectToPricing}
        />
        <Box className={styles.image} />
      </Stack>
    </Modal>
  );
}

export default FinalCreditModal;
